import { SITE_URL } from "@/libs/constants"
import { stripHtmlFromString } from "@/libs/helpers"

export function makeAbsolute(url: string) {
  if (url.startsWith("/")) {
    return SITE_URL + url
  } else if (!url.startsWith("http")) {
    return SITE_URL + "/" + url
  }
  return url
}

export const createImageObject = (url: string, width = 1200, height = 630) => ({
  "@type": "ImageObject",
  url: makeAbsolute(url),
  width,
  height,
})

export const createPerson = ({
  name,
  description,
  imageUrl,
}: {
  name: string
  description?: string
  imageUrl?: string | null
}) => {
  const authorUrl = makeAbsolute(
    `/author/${name.toLowerCase().replace(/\s+/g, "-")}`,
  )
  return {
    "@type": "Person",
    name,
    ...(description && { description }),
    ...(imageUrl && { image: createImageObject(imageUrl, 500, 500) }),
    url: authorUrl,
    sameAs: [authorUrl],
    "@id": `${authorUrl}#person`,
    worksFor: {
      "@type": "Organization",
      name: "the DONUT",
      url: "https://thedonut.co",
    },
  }
}

export const createWebPage = (pathname: string) => ({
  "@id": makeAbsolute(pathname),
  "@type": "WebPage",
})

export const createOrganization = () => ({
  "@type": "Organization",
  name: "the DONUT",
  url: SITE_URL,
  publishingPrinciples: makeAbsolute("/about"),
  logo: createImageObject("/static/donut-logo.png", 600, 60),
})

export const createThing = (name: string) => ({
  "@type": "Thing",
  name,
})

export const createArticle = ({
  title,
  description,
  url,
  datePublished,
  imageUrl,
  authorName,
  useAuthorId = false,
  isPartOf,
}: {
  title: string
  description: string
  url: string
  datePublished: string
  imageUrl?: string
  authorName: string
  useAuthorId?: boolean
  isPartOf?: {
    "@type": "CreativeWorkSeries"
    name: string
    url: string
  }
}) => {
  const authorUrl = makeAbsolute(
    `/author/${authorName.toLowerCase().replace(/\s+/g, "-")}#person`,
  )

  return {
    "@type": "Article",
    headline: title,
    description: stripHtmlFromString(description),
    url: makeAbsolute(url),
    datePublished,
    ...(imageUrl && { image: createImageObject(imageUrl) }),
    author: useAuthorId
      ? { "@id": authorUrl }
      : createPerson({ name: authorName }),
    ...(isPartOf && { isPartOf }),
  }
}
